import { render, staticRenderFns } from "./IndustryAdd.vue?vue&type=template&id=a8f97cc0&scoped=true"
import script from "./IndustryAdd.vue?vue&type=script&lang=js"
export * from "./IndustryAdd.vue?vue&type=script&lang=js"
import style0 from "./IndustryAdd.vue?vue&type=style&index=0&id=a8f97cc0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8f97cc0",
  null
  
)

export default component.exports